exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".products-services-page .content{margin-top:10px}.products-services-page.mobile .card-monitor-component{max-width:100%}.products-services-page.mobile .header-filter-components{margin:0}", ""]);

// exports
